import http from "@/utils/http";

export default {
    getList: (data) => http({ url: '/api/admin/v1/settlementCard/list', data }),
    detail: (data) => http({ url: '/api/admin/v1/settlementCard/detail', data }),
    audit: (data) => http({ url: '/api/admin/v1/settlementCard/audit', data, tip: true }),
    companyDetail: (data) => http({ url: '/api/admin/v1/settlementCard/companyDetail', data }),
    bankList: (data) => http({ url: '/api/admin/v1/settlementCard/bankList', data }),
    branchList: (data) => http({ url: '/api/admin/v1/settlementCard/branchList', data }),
    companySave: (data) => http({ url: '/api/admin/v1/settlementCard/companySave', data, tip: true }),
};
